import WAboutSpecializedReport from './WAboutSpecializedReport'

export default WAboutSpecializedReport
